module.exports = __webpack_public_path__ + "e26231c4a277aa2e135f55c900f9776e.svg";